(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/ttl-cache/assets/javascripts/ttl-cache-async.js') >= 0) return;  svs.modules.push('/components/lb-utils/ttl-cache/assets/javascripts/ttl-cache-async.js');
"use strict";


const isServer = typeof exports === 'object';

const trinidad = isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;

const getLogger = isServer ? trinidad.logger : svs.core.log.getLogger;
const logger = getLogger('banner_layouts:griditem-quickplay');

class TTLCacheAsync {
  constructor(_ref) {
    let onRefreshAsync = _ref.onRefreshAsync,
      ttl = _ref.ttl,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? null : _ref$onError,
      _ref$timeoutMS = _ref.timeoutMS,
      timeoutMS = _ref$timeoutMS === void 0 ? null : _ref$timeoutMS;
    this._onRefreshAsync = onRefreshAsync;
    this._ttl = ttl;
    this._cache = {};
    this._onError = onError;
    this._timeoutMS = timeoutMS;
  }

  async readAsync(_ref2) {
    let key = _ref2.key,
      payload = _ref2.payload;
    if (this._cache[key]) {
      const _this$_cache$key = this._cache[key],
        lastUpdateTS = _this$_cache$key.lastUpdateTS,
        data = _this$_cache$key.data;
      if (Date.now() < lastUpdateTS + this._ttl) {
        return data;
      }
    }
    await new Promise(resolve => {
      let timer;
      let hasResolved = false;
      const _resolveWithoutOrBeforeTimeout = () => {
        if (!hasResolved) {
          if (timer) {
            clearTimeout(timer);
          }
          hasResolved = true;
          resolve(null);
        }
      };
      const _resolveAfterTimeout = () => {
        if (!hasResolved) {
          logger.info("TTLCacheAsync: Timeout after ".concat(this._timeoutMS, " milliseconds (key \"").concat(key, "\")"));
          hasResolved = true;
          resolve(null);
        }
      };
      if (this._timeoutMS && this._timeoutMS > 0) {
        timer = setTimeout(_resolveAfterTimeout, this._timeoutMS);
      }
      this._refreshAsync({
        key,
        payload,
        resolve: _resolveWithoutOrBeforeTimeout
      });
    });
    return this._cache[key].data;
  }

  async _refreshAsync(_ref3) {
    let key = _ref3.key,
      payload = _ref3.payload,
      resolve = _ref3.resolve;
    const _ref4 = this._cache[key] || {},
      isAlreadyRefreshing = _ref4.isAlreadyRefreshing;
    if (isAlreadyRefreshing) {
      this._cache[key].pendingResolvers.push(resolve);
      return;
    }
    if (!this._cache[key]) {
      this._cache[key] = {};
    }
    this._cache[key].isAlreadyRefreshing = true;
    this._cache[key].pendingResolvers = [resolve];
    try {
      this._cache[key].data = await this._onRefreshAsync({
        key,
        payload
      });
    } catch (error) {
      if (this._onError) {
        this._onError(error);
      }
    }
    this._cache[key].lastUpdateTS = Date.now();
    this._cache[key].isAlreadyRefreshing = false;
    this._cache[key].pendingResolvers.splice(0).forEach(item => item());
  }
}
if (isServer) {
  module.exports = {
    TTLCacheAsync
  };
} else {
  setGlobal('svs.components.lbUtils.ttlCache.TTLCacheAsync', TTLCacheAsync);
}

 })(window);